import React, { ReactElement } from "react";
import { VStack } from "web/react/emo/v-stack";
import { OrderCard } from "web/react/pages/account/order-history/order-card";
import { CheckoutOrderHistorySerializer } from "web/types/serializers";

export function OrderList({ orders }: { orders: CheckoutOrderHistorySerializer[] }): ReactElement {
    return (
        <VStack spacing="md">
            {orders.map((order) => (
                <OrderCard key={order.id} order={order} />
            ))}
        </VStack>
    );
}
